import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { setupCallRecordingApi } from "../api/admin";

export const useSetupCallRecordingApi = (onSuccessNavigate) => {
  const [formErrors, setFormErrors] = useState({});

  const { mutate: setupCallRecordingApiMutate, isLoading } = useMutation({
    mutationFn: async (data) => {
      await setupCallRecordingApi(data);
    },
    onSuccess: () => {
      setFormErrors({});
      toast.success("iPECS call recording is set up");
      setTimeout(() => onSuccessNavigate(), 1500);
    },
    onError: (error) => {
      if (error?.response?.status === 422) {
        const errors = error?.response?.data?.errors ?? {};
        const message = error?.response?.data?.message ?? null;
        setFormErrors(errors);
        if (Object.keys(errors).length === 0 && message) {
          toast.error(message);
        }
      } else {
        toast.error(
          "There was a problem setting up Sidekick. Please try again.",
        );
      }
    },
  });

  return { setupCallRecordingApiMutate, formErrors, isLoading };
};
